module.exports = __webpack_public_path__ + "static/media/4.db3fad24.png";